module.exports = __webpack_public_path__ + "img/app_model.366642fd.png";